import { createWidget } from '@funtech-int/rival';

import { ProfilesScreenProps } from './components/ProfilesScreen/ProfilesScreen';

export const profilesScreenWidget = createWidget<unknown, ProfilesScreenProps>();
